import React, { useState, useEffect,useCallback } from 'react';
import PageHeader from '../../components/PageHeader';
import AppHeader from '../../components/AppHeader';
import AppSidebar from '../../components/AppSidebar';
import { useForm } from 'react-hook-form';
import { toast, ToastContainer } from 'react-toastify';
import Assign from '../../modals/Assign';
import Import from '../../modals/Import';
import UsersService from '../../services/UsersService';
import ProfilingService from '../../services/ProfilingService';
import ChangeStatusModal from '../../modals/ChangeStatus';
import CommonTable from '../../components/CommonTable';
import Pagination from '../../components/Pagination';
import Filters from '../../components/Filters';
import UseDebounce from '../../hooks/UseDebounce';
import { PageLimit } from '../../utils/ConstantUtils';
import { DebounceDelay } from '../../utils/ConstantUtils'
import { profilingStatusOptions } from '../../utils/OptionUtils';

const Profiling = ({ type }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const pageLimit = PageLimit ;
  const [itemsPerPage, setPageLimit] = useState(pageLimit);
  const offset = (currentPage - 1) * itemsPerPage;
  const [appliedFilters, setAppliedFilters] = useState({});
  const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const { control: statusControl, handleSubmit: handleStatusSubmit } = useForm();
  const [selectedProfileId, setSelectedProfileId] = useState(null);
    
  const columns = [
    { Header: '', accessor: '', sample: 'Sample Data' },
    { Header: '#', accessor: 'id', sample: 'Sample Data' },
    { Header: 'Company', accessor: 'company', sample: 'Sample Data' },
    { Header: 'Name', accessor: 'name', sample: 'Sample Data' },
    { Header: 'Email', accessor: 'email', sample: 'Sample Data' },
    { Header: 'Phone No', accessor: 'phone', sample: 'Sample Data' },
    { Header: 'Mobile No', accessor: 'mobile_no', sample: 'Sample Data' },
    { Header: 'Department', accessor: 'department', sample: 'Sample Data' },
    { Header: 'Designation', accessor: 'designation', sample: 'Sample Data' },
    { Header: 'Product Name', accessor: 'product', sample: 'Sample Data' },
    { Header: 'Source', accessor: 'source', sample: 'Sample Data' },
    { Header: 'Industry Type', accessor: 'industry_type', sample: 'Sample Data' },
    { Header: 'Zipcode', accessor: 'zipcode', sample: 'Sample Data' },
    { Header: 'Status', accessor: 'status', sample: 'Sample Data' },
    { Header: 'Address', accessor: 'address', sample: 'Sample Data' },
    { Header: 'City', accessor: 'city', sample: 'Sample Data' },
    { Header: 'State', accessor: 'state', sample: 'Sample Data' },
    { Header: 'Country', accessor: 'country', sample: 'Sample Data' },
    { Header: 'Created By', accessor: 'createdBy', sample: 'Sample Data' },   
    { Header: 'Assigned To', accessor: 'assignedTo', sample: 'Sample Data' }, 
    { Header: 'Assigned By', accessor: 'assignedBy', sample: 'Sample Data' }   
  
  ];
  const instructions = [
    "Your file data should be in the format below. The first line of your file should be the column headers as in the table example. Also make sure that your file is UTF-8 to avoid unnecessary encoding problems.",
    "If the column you are trying to import is date, make sure that it is formatted as Y-m-d (e.g., 2024-09-05).",
    "Based on your data unique validation configured options, the lead won't be imported if: Lead company already exists. If you still want to import all data, uncheck all unique validation fields."
  ];
  const [selectedRows, setSelectedRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const { formState: { errors }, control, handleSubmit } = useForm();
  const [AssigneeList, setAssigneeList] = useState([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const handleCloseImportModal = () => setShowImportModal(false);
  const handleShowImportModal = () => setShowImportModal(true);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ProfilingService.getAllProfiling({
        page: currentPage,
        limit: itemsPerPage,
        search: debouncedSearchTerm,
        offset: offset,
        filters: appliedFilters,
        type : type
      });
      if (response.status === 200 && response.data.success) {
        setRows(response?.data?.data?.data);
        setTotalPages(response?.data?.data?.totalPages);
        setCurrentPage(response?.data?.data?.currentPage);
        await fetchAssignees();
      } else {
        console.error('Error in fetching profillings data:', response);
      }
    } catch (error) {
      console.error('Error in fetching profillings data:', error);
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, debouncedSearchTerm, offset, appliedFilters,type]);

  const fetchAssignees = async () => {
    try {
      const response = await UsersService.list();
      const formattedAssigneeList = response.data.data.map(assignee => ({
        value: assignee.id,
        label: assignee.name + ' - ' + assignee.email,
      }));
      setAssigneeList(formattedAssigneeList);
    } catch (err) {
      console.error('Failed to load assignees');
    }
  };

  useEffect(() => {
    fetchData();
  }, [appliedFilters,fetchData]);

  const onSubmit = async (data) => {
    const assigneeIds = data.assignee.map((assignee) => assignee.value);
  
    try {
      for (let profileId of selectedRows) {
        const requestBody = {
          data: {
            assigned_to: assigneeIds,
          },
        };
  
        const response = await ProfilingService.profilingAssignToUser(profileId, requestBody);
  
        if (response.status === 200) {
          const profileResponse = await ProfilingService.getProfiling(profileId);
          if (profileResponse.status) {
            updateProfileInRows(profileResponse.data.data);
          }
        } else {
          toast.error(`Failed to assign profile ID ${profileId}`);
        }
      }
  
      toast.success('Profiles assigned to user(s) successfully');
      handleCloseAssignModal();
    } catch (error) {
      toast.error('An error occurred. Please try again.');
    }
  };
  

  const onSubmitStatus = async (data) => {
    if (!selectedProfileId) return; 
    try {
        const { status } = data;
        const requestBody = {
            data: {
                status: status ? status.value : null,
            },
        };
        const response = await ProfilingService.changeProfilingStatus(selectedProfileId, requestBody);

        if (response.status === 200) {
          setRows(prevRows => prevRows.map(row => 
            row.id === selectedProfileId ? { ...row, status: data.status.value } : row
          ));            
          toast.success("Profile status updated successfully");
          handleCloseStatusModal();
        }
        else {
            toast.error(response.message || "An error occurred.");
        }

    } catch (error) {
        toast.error(error?.message || "An error occurred.");

    }
};

const handleShowStatusModal = (profileId) => {
  setSelectedProfileId(profileId); 
  setShowStatusModal(true);
};

const handleCloseStatusModal = () => {
  setShowStatusModal(false);
  setSelectedProfileId(null); 
};

const getStatusBadgeClass = (status) => {
  switch (status) {
    case 'verified':
      return 'badge bg-success'; 
    case 'unverified':
      return 'badge bg-danger'; 
    case 'pending':
      return 'badge bg-warning';
    default:
      return 'badge bg-secondary'; 
  }
};

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleItemsPerPageChange = (e) => {
    setCurrentPage(1);
    setPageLimit(e.target.value);
  };

  const handleFilterSubmit = (newFilters) => {
    setAppliedFilters(newFilters);
  };


  const handleShowAssignModal = (profileIds) => {
    setSelectedRows(profileIds); 
    setShowAssignModal(true);
  }
  
  const handleCloseAssignModal = () => {
    setShowAssignModal(false);
    setSelectedRows([]);
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked && rows.length > 0) {
      setSelectedRows(rows.map(row => row.id));
    } else {
      setSelectedRows([]);
      
    }
  };
 
  const handleCheckboxChange = (rowId) => {
    setSelectedRows(prevSelectedRows =>
      prevSelectedRows.includes(rowId)
        ? prevSelectedRows.filter(id => id !== rowId)
        : [...prevSelectedRows, rowId]
    );
 
    if (!selectedRows.includes(rowId)) {
      
    } else if (selectedRows.length === 1) {
      
    }
  };
 
  const updateProfileInRows = (updatedProfile) => {
    setRows(prevRows =>
      prevRows.map(row => (row.id === updatedProfile.id ? updatedProfile : row))
    );
  };

  const refreshData = () => {
    fetchData();
  };

  const filterFields = [
    { name: 'company', placeholder: 'Company', Dropdown : "yes" },
    { name: 'name', placeholder: 'Name' , Dropdown : "yes" },
    { name: 'email', placeholder: 'Email' , Dropdown : "yes" },
    { name: 'phone', placeholder: 'Phone No' , Dropdown : "yes" },
    { name: 'mobile_no', placeholder: 'Mobile No' , Dropdown : "yes" },
    { name: 'department', placeholder: 'Department' , Dropdown : "no" },
    { name: 'designation', placeholder: 'Designation' , Dropdown : "no" },
    { name: 'product_id', placeholder: 'Product Name' , Dropdown : "yes" },
    { name: 'source', placeholder: 'Source' , Dropdown : "yes" },
    { name: 'industry_type', placeholder: 'Industry Type' , Dropdown : "yes" },
    { name: 'status', placeholder: 'Status' , Dropdown : "yes" },
    { name: 'city', placeholder: 'City' , Dropdown : "yes" },
    { name: 'created_by', placeholder: 'Created By' , Dropdown : "yes" },
    { name: 'assigned_to', placeholder: 'Assigned To' , Dropdown : "yes" },
    { name: 'assigned_by', placeholder: 'Assigned By' , Dropdown : "yes" },
    { name: 'unassigned', placeholder: 'Check Unassigned' , Dropdown : "yes" },

  ];

  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 ">
                <PageHeader
                title={type ? "Verified" : "Profiling"}
                button_label="Create"
                button_label1="Import Data"
                link_to="create"
                buttonAttributes1={{ onClick: handleShowImportModal }}
                className="btn btn-sm btn-primary me-2"
                className1="btn btn-sm btn-secondary"
                extraButtons={
                Array.isArray(selectedRows) &&
                selectedRows.length >= 1 &&
                selectedRows.length <= rows.length && (
                  <button
                    className="btn btn-sm btn-danger me-2"
                    onClick={() => handleShowAssignModal?.(selectedRows)}
                  >
                    Assign Selected
                  </button>
                )}
                />

              <div className="tab-content">
                <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                  <div className="card">
                    <div className="card-header">
                      <div className="row align-items-center">
                        <div className="col">
                          <form>
                            <div className="input-group input-group-flush input-group-merge input-group-reverse">
                              <input
                                className="form-control list-search"
                                type="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={handleSearchChange}
                              />
                              <span className="input-group-text">
                                <i className="fe fe-search" />
                              </span>
                            </div>
                          </form>
                        </div>
                        <div className="col-auto me-n3">
                          <form>
                            <select
                              className="form-select form-select-sm form-control-flush"
                              value={itemsPerPage}
                              onChange={handleItemsPerPageChange}
                            >
                              <option value="20">20 per page</option>
                              <option value="40">40 per page</option>
                              <option value="60">60 per page</option>
                              <option value="100">100 per page</option>
                            </select>
                          </form>
                        </div>
                        <div className="col-auto">
                          {/* Use the Filters component here */}
                          <Filters filterFields={filterFields} onApplyFilters={handleFilterSubmit} getFilterService={ProfilingService.getProfilingFilter} />
                        </div>
                      </div>
                    </div>

                    {/* Common Table component*/}
                    <CommonTable
                      loading={loading}
                      rows={rows}
                      columns={columns}
                      onSelectAllChange={handleSelectAllChange}
                      onCheckboxChange={handleCheckboxChange}
                      selectedRows={selectedRows}
                      handleShowAssignModal={handleShowAssignModal}
                      setSelectedRows={setSelectedRows}
                      basePath="profiling"
                      showLimitedOptions={false}
                      handleShowStatusModal = {handleShowStatusModal}
                      getStatusBadgeClass = {getStatusBadgeClass}
                      offset = {offset}
                    />
                    <ToastContainer />

                    {/* Pagination Component */}
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      setCurrentPage={setCurrentPage}
                    /> 

                    {/* Assign Modal */}
                    <Assign
                      show={showAssignModal}
                      handleClose={handleCloseAssignModal}
                      handleSubmit={handleSubmit}
                      control={control}
                      AssigneeList={AssigneeList}
                      onSubmit={onSubmit}
                      errors={errors}
                    />

                    {/* Change Status Modal */}
                    <ChangeStatusModal
                        show={showStatusModal}
                        handleClose={handleCloseStatusModal}
                        handleSubmit={handleStatusSubmit}
                        control={statusControl}
                        status={profilingStatusOptions}
                        onSubmit={onSubmitStatus}
                        errors={errors}
                    />

                    {/* Import Modal */}
                    <Import
                      show={showImportModal}
                      handleClose={handleCloseImportModal}
                      refreshData={refreshData}
                      modalTitle="Import Profiling"
                      pageHeaderTitle="Profiling Data"
                      service={ProfilingService}
                      columns={columns}
                      instructions={instructions}
                      statusOptions={profilingStatusOptions}
                      sampleFileUrl="/assets/sample files/sample_profiling_import_file.xlsx"
                      sampleFileName="sample_profiling_import_file.xlsx"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profiling;